import { render, staticRenderFns } from "./productMenuPivotList.vue?vue&type=template&id=fe66a20e&scoped=true&"
import script from "./productMenuPivotList.vue?vue&type=script&lang=babel&"
export * from "./productMenuPivotList.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe66a20e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCheckbox,VDivider})
